import HashratesWidget from './HashratesWidget';

export default HashratesWidget;
